import { defineMessages } from 'react-intl';

export default defineMessages({
    defaultTitle: {
        id: '_.draw_down.iwocaPay.order_summary.title',
        defaultMessage: 'Your payment plan'
    },
    subTitle: {
        id: '_.draw_down.iwocaPay.order_summary.sub_title',
        defaultMessage: '(Outstanding amount: {amount})'
    },
    interestRateDisclaimer: {
        id: '_.draw_down.iwocaPay.order_summary.interestRateDisclaimer',
        defaultMessage: '*Your interest rate is {interestRate} per month.'
    }
});
